/* eslint-disable jira/filename-case */
export const CLEAR_SEARCH_SESSION = 'CLEAR_SEARCH_SESSION';

// Dont clear the session until clear session event is fired
export const skipClearSessionURLs: readonly [RegExp, RegExp, RegExp] = [
	/.*RapidBoard.jspa.*/,
	/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
	/\/jira\/people\/.*\/boards\/.*/,
] as const;
